import React from 'react';
import { Form, Progress } from 'antd';

class DepositFail extends React.Component {
    render() {
        return (
            <div>
                <Progress type="circle" percent={100} width={50} status="exception" />
                <br />
                <br />
                <h3>Your deposit was not successful.  Please contact <a href="mailto:finance@isevoyages.org">finance@isevoyages.org</a> to make sure your payment has gone through before trying again.</h3>
                <br />
            </div>
        );
    }
}

export default Form.create()(DepositFail);



// WEBPACK FOOTER //
// ./src/containers/Login/DepositFail.jsx